import { clsx } from "clsx"
import { Unlock } from "lucide-react"

export function URLView({ url: _url, compact }: { url: string; compact: boolean }) {
  if (_url === ":") {
    return (
      <div css={clsx(compact && "flex items-center truncate")} title=":">
        <span css="opacity-70">:</span>
      </div>
    )
  }

  const url = new URL(_url)

  return (
    <div>
      <div css={clsx(compact && "flex items-center truncate")} title={url.pathname}>
        <URLProtocol compact={compact} protocol={url.protocol} />
        <span>
          {url.host}
          {url.pathname}
          {url.search ? <QueryView query={url.search} /> : null}
        </span>
      </div>
    </div>
  )
}

function URLProtocol({ protocol, compact }: { protocol: string; compact: boolean }) {
  if (protocol === "https:") {
    return null
  }

  let icon: React.ReactNode

  if (protocol === "http:" && compact) {
    icon = <Unlock size={16} />
  }

  return (
    <>
      {icon != null && <span css="mr-1">{icon}</span>}
      <span css="opacity-70">{protocol}</span>
      {"//"}
    </>
  )
}

export function QueryView({ query }: { query: string }) {
  return <span css="opacity-50">{query}</span>
}
